<script>
import { useEvaluationFeedbackActions } from '@/stay-displayer/composables/useEvaluationFeedbackActions'

import ApiJustificationSummary from './ApiJustificationSummary.vue'

export default {
  components: {
    'justification-summary': ApiJustificationSummary,
  },
  props: {
    appSettings: { type: Object, required: true },
    type: { type: String, required: true },
    isLoading: { type: Boolean, default: false },
    isWildcard: { type: Boolean, default: false },
    selected: { type: Boolean, required: true },
    suggestedDiagnosis: { type: Object, required: true },
    healthData: { type: Object, required: true },
    suggestionJustifications: { type: Object, default: null },
    iaEnabled: { type: Boolean, default: true },
  },
  emits: ['make-selection'],
  setup() {
    return { evaluationFeedbackActions: useEvaluationFeedbackActions() }
  },
  data() {
    return {
      showJustificationSummary: false,
    }
  },
  computed: {
    apiJustification() {
      if (this.isWildcard) {
        return null
      }

      return this.suggestionJustifications?.[`${this.type}:${this.suggestedDiagnosis.reference}`] ?? null
    },
  },
  methods: {
    makeSelection() {
      this.$emit('make-selection', {
        labelType: this.type,
        labelReference: this.suggestedDiagnosis.reference,
        savedSearchIds: this.suggestedDiagnosis.staySavedSearches.map((ss) =>ss.search.id),
      })
    },
    toggleRationals() {
      if (!this.isWildcard) {
        this.showJustificationSummary = !this.showJustificationSummary
        this.makeSelection()
      }
    },
    handleHealthDataSelection(mainContent, scrollTarget = null) {
      this.$store.commit('setScrollTarget', scrollTarget)
      this.$store.commit('setMainContent', mainContent)
      if (!this.selected) {
        this.makeSelection()
      }
      this.showJustificationSummary = !this.showJustificationSummary
    },
    flagJustification(payload) {
      this.$store.dispatch('createFalseJustificationForSuggestion', payload)
    },
    unflagJustification({ justificationId, docType, docId }) {
      this.$store.dispatch('deleteFalseJustification', {
        justificationId,
        reportId: docType === 'report' ? docId : null,
        healthEntryId: docType === 'textualHealthEntry' ? docId : null,
      })
    },
  }
}
</script>

<template>
  <div
    :class="{
      selected: showJustificationSummary,
      'diagnosis-title': !isWildcard,
      'diagnosis-group-title': isWildcard,
      'ia-disabled': !iaEnabled && suggestedDiagnosis.prediction && !suggestedDiagnosis.staySavedSearches.length,
    }"
    @click="toggleRationals"
  >
    <v-dropdown
      v-if="!isWildcard"
      :shown="showJustificationSummary"
      placement="left"
      class="popover-container"
      popover-class="justification-popover"
      @hide="showJustificationSummary=false"
    >
      <slot />
      <template #popper>
        <justification-summary
          :is-loading="isLoading"
          :justification="suggestedDiagnosis.canShowRational ? apiJustification : null"
          :health-data="healthData"
          :label-type="type"
          :label-reference="suggestedDiagnosis.reference"
          :feedback-actions="evaluationFeedbackActions"
          @select-health-data="handleHealthDataSelection"
          @flag-justification="flagJustification"
          @unflag-justification="unflagJustification"
        />
      </template>
    </v-dropdown>
    <!-- Wildcard parent rows are pure toggles : justifications live on the expanded children -->
    <slot v-else />
  </div>
</template>
